import Axios from 'axios';
import { Claim } from '@/models/Claim';

/**
 * Loads the claims for a specific prescription fill.
 * Centralizes the `Insurance/GetClaims/{store}/{rx}/{rf}` call (previously inlined in several components).
 */
export async function getClaimsForRx(
    storeId: number,
    rxNumber: number,
    rfNumber: number | undefined,
): Promise<Claim[]> {
    const response = await Axios.get<Claim[]>(`/api/Insurance/GetClaims/${storeId}/${rxNumber}/${rfNumber ?? 0}`);
    return response.data;
}
